
import React from "react";
import { SidebarMobileProps } from "./SidebarMobile.types";
import styled from "styled-components";
import "./SidebarMobile.scss";
import { useTranslation } from "react-i18next";

const SidebarMobileWrapper = styled.div`
  z-index: -100;
  width: 100%;
  background: #ffffff;
  padding-top: 30px;
  position: absolute;
  top: 70px;
  left: 0;
  transition: opacity 0.1s ease-out;
  opacity: 0;
`

export const SidebarMobile: React.FC<SidebarMobileProps> = ({ menu,isVisible }) => {
  const { t } = useTranslation();
  
  return(
    <SidebarMobileWrapper className={isVisible ? "sidebar-mobile-visible" : ''}>
      {menu && menu.length > 0 &&
      <>
        {
          menu.map((item, index) => {
            return (
                <div key={index} className={item.isActive ? `sidebarmobile-menu-item sidebarmobile-menu-item-active` : 'sidebarmobile-menu-item'} onClick={() => item.clickAction()}>
                  <span>{item.name ? t((item.name + '_tag_plain').toLocaleLowerCase()) : ''}</span>
                  {item.isActive ? <img src={item.iconactive}/> : <img src={item.icondark}/>}
                </div>
            );
          })
        }
      </>
      }
    </SidebarMobileWrapper>
  )
};

